import DeleteIcon from '@mui/icons-material/Delete'
import { Box, Menu, MenuItem } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import editIcon from '@/assets/images/EditIcon.svg'

import DeleteProject from '../projects/DeleteProject'
import EditProject from '../projects/EditProject'

interface ActionMenuProps {
  anchorEl: null | HTMLElement
  handleMenuClose: () => void
  refetch: () => void
  caseDetails: any
}

const ProjectDetailMenu: React.FC<ActionMenuProps> = ({
  anchorEl,
  handleMenuClose,
  refetch,
  caseDetails,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'ProjectDetails.ProjectDetailsActions',
  })

  const [editOpen, setEditOpen] = useState(false)
  const [selectedCase, setSelectedCase] = useState<any | null>(null)
  const [isDeleteDialog, setIsDeleteDialog] = useState(false)
  const [caseIdToDelete, setCaseIdToDelete] = useState<string | null>(null)

  const handleEdit = async () => {
    setSelectedCase({
      id: caseDetails?.id,
      patient_name: caseDetails?.name,
      description: caseDetails?.description,
      dentist: caseDetails?.dentist,
    })
    setEditOpen(true)
  }

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        slotProps={{
          paper: {
            sx: {
              bgcolor: 'rgba(41, 41, 41, 1)',
              color: 'white',
              mt: 1,
              boxShadow:
                '0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
              borderRadius: '4px',
            },
          },
          list: {
            sx: {
              bgcolor: 'rgba(41, 41, 41, 1)',
            },
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem
          onClick={() => {
            handleMenuClose()
            handleEdit()
          }}
          sx={{ '&:hover': { backgroundColor: '#33393E' } }}
        >
          <Box
            component="img"
            src={editIcon}
            alt="Edit"
            sx={{ width: 24, height: 24, mr: '12px' }}
          />
          {t('edit')}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMenuClose()
            setCaseIdToDelete(caseDetails?.id)
            setIsDeleteDialog(true)
          }}
          sx={{ '&:hover': { backgroundColor: '#33393E' } }}
        >
          <DeleteIcon sx={{ mr: '12px' }} />
          {t('delete')}
        </MenuItem>
      </Menu>
      {selectedCase && (
        <EditProject
          open={editOpen}
          onClose={() => setEditOpen(false)}
          initialData={selectedCase}
          refetchRecipe={refetch}
        />
      )}

      <DeleteProject
        isOpen={isDeleteDialog}
        onClose={() => {
          setIsDeleteDialog(false)
          setCaseIdToDelete(null)
        }}
        caseId={caseIdToDelete}
        refetch={refetch}
      />
    </>
  )
}

export default ProjectDetailMenu
